import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'angular2-smart-table';
import { take } from 'rxjs/internal/operators/take';
import { EventService } from '../../services/database/event/event.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'ngx-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss']
})
export class MarketingComponent implements OnInit {
  message: string;
  source: LocalDataSource = new LocalDataSource();
  eventId: string;

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
      position: 'right'
    },
    columns: {
      timestamp: {
        title: 'Date',
        type: 'date'
      },
      message: {
        title: 'Message',
        type: 'string',
      }
    },
  };
  constructor(
    private afStore: AngularFirestore,
    private route: ActivatedRoute,
    private eventService: EventService
  ) { }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId');
    this.afStore.collection('eventnotification', ref => ref.where('eventId', '==', this.eventId).orderBy('timestamp', 'desc')).valueChanges().subscribe((notifications:any) => {
      const data = [];
      notifications.forEach(notification => {
        data.push({
          timestamp: formatDate(notification.timestamp.toDate(), 'dd/MM/yyyy HH:mm', 'en-US'),
          message: notification.message
        })
      })
      this.source.load(data);
  });
}

  addNotification() {
    const message = this.message;
    this.message = '';
    return this.eventService.getEvent(this.eventId).pipe(take(1)).subscribe((event) => {
      return this.afStore.collection('eventnotification').add({
        eventId: this.eventId,
        title: event.name,
        message: message
      })
    })
  }

}
